import { useCallback, useMemo } from "react";
import { ApolloQueryResult, useApolloClient } from "@apollo/client";
import { QueryInfo } from "@apollo/client/core/QueryInfo";
import { QueryManager } from "@apollo/client/core/QueryManager";
import { DocumentNode } from "graphql";

export function useRefetchQuery(...documents: DocumentNode[]) {
  const queryManager = (useApolloClient() as any).queryManager as (Omit<QueryManager<any>, "queries"> & {
    queries: Map<string, QueryInfo>,
    getQuery: (queryId: string) => QueryInfo
  });
  const bodies = useMemo(
    () => documents.map(x => x.loc?.source?.body),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ ...documents ],
  );

  return useCallback(() => {
    const observableQueryPromises: Promise<ApolloQueryResult<any>>[] = [];
    queryManager.queries.forEach(({ observableQuery, document }, queryId) => {
      if (observableQuery && bodies.includes(document?.loc?.source?.body)) {
        const fetchPolicy = observableQuery.options.fetchPolicy;

        observableQuery.resetLastResults();
        if (
          fetchPolicy !== "cache-only" &&
          fetchPolicy !== "standby"
        ) {
          observableQueryPromises.push(observableQuery.refetch());
        }

        queryManager.getQuery(queryId)
          .setDiff(null);
      }
    });

    queryManager.broadcastQueries();

    return Promise.all(observableQueryPromises);

  }, [ bodies, queryManager ]);
}
